// import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import Device from './../util/Device';
import innerHeight from 'ios-inner-height';

export default class {

  constructor () {
    this.isOpen = false
    this.isMobile = false
    this.iosHeightInterval = null
    this.iosCurrentHeight = null
    this.$main = null
    this.$active = null
    this.$activeTrigger = null
    this.$overlay = null
  }

  init () {
    this.$main = $('#megaContainer')
    $('[data-has-mega]').on('click', (e) => {
      e.preventDefault()
      let $trigger = $(e.currentTarget)
      let target = $trigger.data('mega-key')
      this.openMega(
        $trigger,
        $(`[data-mega-container="${target}"]`)
      )
    })
    $('.js-close-mega').on('click', () => {
      this.closeMega()
    })
    Device.registerCallbacks((name, { newDevice }) => {
      // On width change, we simply collapse mobile nav
      if (name !== 'change') {
        return
      }
      this.handleResponsiveChange(newDevice)
    })
    this.handleResponsiveChange(Device.device)
  }

  openMega ($trigger, $target) {
    if ($target.is(this.$active)) {
      // disableBodyScroll($target[0])
      this.closeMega()
      return
    }

    if (this.$active) {
      this.$activeTrigger.removeClass('is-active')
      this.$active.removeClass('is-active')
      // disableBodyScroll(this.$active[0])
    } else {
      this.addOverlay()
      this.attachClickOutside()
    }

    this.$activeTrigger = $trigger
    this.$active = $target
    // enableBodyScroll($target[0])
    this.$active.addClass('is-active')
    this.$main.addClass('is-open')
    this.$activeTrigger.addClass('is-active')
    this.isOpen = true
  }

  closeMega () {
    this.$main.removeClass('is-open')
    this.$activeTrigger && this.$activeTrigger.removeClass('is-active')
    this.$active && this.$active.removeClass('is-active')
    this.isOpen = false
    this.$active = null
    this.$activeTrigger = null
    this.removeOverlay()
  }

  addOverlay () {
    this.$overlay = $('<div id="megaOverlay" class="fixed z-30 top-0 left-0 w-full h-full opacity-50 bg-white"></div>')
    this.$overlay.appendTo('main.main')
  }

  removeOverlay () {
    if (!this.$overlay) {
      return
    }
    this.$overlay.remove()
    this.$overlay = null
  }

  handleResponsiveChange (newDevice) {
    if (['md', 'lg', 'xl'].indexOf(newDevice) !== -1) {
      this.isMobile = false
    } else {
      this.isMobile = true
    }

    if (this.isMobile) {
      // Helps account for ios collapsible footer nav
      this.iosCurrentHeight = null
      this.iosHeightInterval = setInterval(() => {
        if (this.iosCurrentHeight === innerHeight()) {
          return
        }
        this.iosCurrentHeight = innerHeight()
        $('[data-mega-container]').css({
          'maxHeight': `${this.iosCurrentHeight}px`,
        })
      }, 100);
    } else {
      if (this.iosHeightInterval) {
        clearInterval(this.iosHeightInterval)
        this.iosCurrentHeight = null
        $('[data-mega-container]').css({
          'maxHeight': null,
        })
      }
    }
  }

  attachClickOutside () {
    const outsideClickListener = event => {
      let $target = $(event.target)
      if ($target.closest('.nav-primary').length || $target.closest('.nav-primary-right').length || $target.closest('#megaContainer').length) {
        return
      }
      this.closeMega()
      removeClickListener()
    }
    const removeClickListener = () => {
        document.removeEventListener('click', outsideClickListener)
    }
    document.addEventListener('click', outsideClickListener)
  }
}



// WEBPACK FOOTER //
// ./scripts/components/mega-menu.js